module.exports = __webpack_public_path__ + "img/personagem-2.e7e272e6.png";